import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/similar-words",
 headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) config.headers.Authorization = `Bearer ${token}`;
 else return config;
});

// ===== GROUPS =====
export const fetchGroups = async (params = {}) => {
 try {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 const res = await api.get("/groups", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
 }
};
export const fetchGroupById = async (id) => {
 try { const res = await api.get(`/groups/${id}`); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" }; }
};
export const createGroup = async (data) => {
 try { const res = await api.post("/groups", data); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" }; }
};
export const updateGroup = async (id, data) => {
 try { const res = await api.put(`/groups/${id}`, data); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" }; }
};
export const deleteGroup = async (id) => {
 try { const res = await api.delete(`/groups/${id}`); return { status: res.status }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.error || err.response?.data?.message || "Delete failed" }; }
};

// ===== WORDS =====
export const fetchWordsByGroup = async (groupId) => {
 try { const res = await api.get(`/groups/${groupId}/words`); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" }; }
};
export const createWord = async (data) => {
 try { const res = await api.post("/words", data); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" }; }
};
export const updateWord = async (id, data) => {
 try { const res = await api.put(`/words/${id}`, data); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" }; }
};
export const deleteWord = async (id) => {
 try { const res = await api.delete(`/words/${id}`); return { status: res.status }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" }; }
};
export const searchWords = async (searchTerm) => {
 try { const res = await api.get("/words/search", { params: { searchTerm } }); return { status: res.status, data: res.data }; }
 catch (err) { return { status: err.response?.status || 500, message: err.response?.data?.message || "Search failed" }; }
};
